// extracted by mini-css-extract-plugin
export default {"prodBox":"prodBox_prodBox__DTGAI","details":"prodBox_details__6XIw2","price":"prodBox_price__VRmNc"};